export default __webpack_public_path__ + "static/media/dashboard_light_mode.8c2616b3.svg";